'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    outlined: {
        fontSize: `${variables.SIZES.TEXT_SMALL}px`,
        fontWeight: variables.WEIGHTS.MEDIUM,
        color: variables.COLORS.GREYSCALE_25,
        "&$shrink": {
            transform: "translate(0px, -8px)",
            fontWeight: variables.WEIGHTS.MEDIUM,
        },
    },
};

var MuiInputLabel = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiInputLabel = MuiInputLabel;
exports.light = light;
